export default {
  // Header
  "title": "隨機寶可夢生成器",
  "subtitle": "根據您的喜好生成隨機寶可夢",
  "home": "首頁",
  "whichPokemonAmI": "我是哪個寶可夢？",
  "aboutUs": "關於我們",
  "contactUs": "聯絡我們",
  "privacyPolicy": "隱私政策",
  
  // Filters
  "filterTitle": "篩選選項",
  "generateButton": "生成隨機寶可夢",
  "generating": "生成中...",
  "numberOfPokemon": "寶可夢數量",
  "type": "屬性",
  "generation": "世代",
  "minimumRarity": "最低稀有度 (1-10)",
  "anyType": "任意屬性",
  "anyGeneration": "任意世代",
  "anyRarity": "任意稀有度",
  "countingPokemon": "正在統計符合條件的寶可夢",
  "matchingPokemonCount": "{{count}}隻寶可夢符合您的篩選條件",
  "noPokemonToDisplay": "沒有寶可夢可顯示。請生成一些寶可夢！",
  
  // Pokemon Types
  "normal": "一般",
  "fire": "火",
  "water": "水",
  "electric": "電",
  "grass": "草",
  "ice": "冰",
  "fighting": "格鬥",
  "poison": "毒",
  "ground": "地面",
  "flying": "飛行",
  "psychic": "超能力",
  "bug": "蟲",
  "rock": "岩石",
  "ghost": "幽靈",
  "dragon": "龍",
  "dark": "惡",
  "steel": "鋼",
  "fairy": "妖精",
  
  // Generations
  "Generation I": "第一世代",
  "Generation II": "第二世代",
  "Generation III": "第三世代",
  "Generation IV": "第四世代",
  "Generation V": "第五世代",
  "Generation VI": "第六世代",
  "Generation VII": "第七世代",
  "Generation VIII": "第八世代",
  "Generation IX": "第九世代",
  
  // Evolution Stage
  "evolutionStage": "進化階段",
  "evolutionStageAll": "所有階段",
  "evolutionStageFullyEvolved": "完全進化",
  "evolutionStageNotFullyEvolved": "未完全進化",
  
  // About Section
  "aboutTitle": "關於隨機寶可夢產生器",
  
  // Section titles
  "introTitle": "歡迎使用我們的隨機寶可夢生成器",
  "howToUseTitle": "如何使用隨機寶可夢生成器",
  "benefitsTitle": "使用我們的隨機寶可夢生成器的優勢",
  "historyTitle": "寶可夢的歷史",
  "popularPokemonTitle": "熱門寶可夢",
  "popularGamesTitle": "熱門寶可夢遊戲",
  "tradingContestsTitle": "寶可夢交換與比賽",
  "faqTitle": "常見問題",
  "conclusionTitle": "今天就開始您的隨機寶可夢冒險吧！",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "寶可夢和寶可夢角色名稱是任天堂的商標。",
  "linksTitle": "實用連結",
  
  // About Us Page
  "aboutUsTitle": "關於我們",
  "aboutUsWhoWeAre": "我們是誰",
  "aboutUsWhoWeAreContent1": "歡迎來到隨機寶可夢生成器，這是一個由熱情的寶可夢愛好者創建的粉絲工具。我們的旅程始於2023年，當時一群同時熱愛程式設計和寶可夢的開發者決定為社群創建一個實用工具。",
  "aboutUsWhoWeAreContent2": "我們的團隊由開發者、設計師和內容創作者組成，共同努力為全球寶可夢粉絲提供最佳體驗。",
  "aboutUsOurMission": "我們的使命",
  "aboutUsOurMissionContent1": "我們的目標是讓寶可夢世界對所有人來說更加親近和愉快。我們的工具旨在幫助訓練家發現新的寶可夢，建立平衡的團隊，找到自己完美的寶可夢搭配。",
  "aboutUsOurMissionContent2": "我們致力於提供用戶友好、準確且有趣的體驗，既尊重寶可夢品牌，同時為社群增添價值。",
  "aboutUsOurTeam": "我們的團隊",
  "aboutUsOurTeamContent1": "我們多元化的團隊結合了網頁開發、寶可夢知識、用戶體驗設計和社群管理方面的專業知識。我們因對寶可夢的熱愛和創建高品質工具的承諾而團結在一起。",
  "aboutUsOurTeamContent2": "每位團隊成員都貢獻自己獨特的技能和觀點，使隨機寶可夢生成器盡可能地完善。",
  "aboutUsJoinUs": "加入我們",
  "aboutUsJoinUsContent": "我們始終在尋找熱情的個人加入我們的社群。無論您是開發者、設計師、寶可夢專家還是熱心用戶，您的回饋和貢獻都會受到歡迎。",
  
  // Contact Us Page
  "contactUsTitle": "聯絡我們",
  "contactUsGetInTouch": "與我們聯繫",
  "contactUsGetInTouchContent": "對隨機寶可夢生成器有疑問、建議或反饋？我們很樂意聽取您的意見！以下是聯繫我們團隊的方式。",
  "contactUsEmail": "電子郵件",
  "contactUsPhone": "電話",
  "contactUsAddress": "地址",
  "contactUsHelpSupport": "幫助與支援",
  "contactUsHelpSupportContent": "需要使用我們工具的幫助或遇到問題？我們的支援團隊隨時為您提供協助。",
  "contactUsFAQ": "常見問題",
  "contactUsFAQContent": "在聯繫我們之前，請查看我們的常見問題區域，其中涵蓋了許多常見問題和疑難解答。",
  "contactUsBugReport": "錯誤報告",
  "contactUsBugReportContent": "如果您發現錯誤或技術問題，請透過電子郵件告知我們，主旨為「錯誤報告」。",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "隱私政策",
  "privacyPolicyIntro": "簡介",
  "privacyPolicyIntroContent": "在隨機寶可夢生成器，我們尊重您的隱私並致力於保護您的個人資料。本隱私政策說明我們在您使用我們的網站時如何收集、使用和保護您的資訊。",
  "privacyPolicyInformation": "我們收集的資訊",
  "privacyPolicyInformationContent": "我們僅收集最低限度的資訊來提供和改進我們的服務。這可能包括：",
  "privacyPolicyInformationItem1": "使用數據（如瀏覽的頁面、在網站上花費的時間以及使用的功能）",
  "privacyPolicyInformationItem2": "裝置資訊（瀏覽器類型、作業系統和螢幕解析度）",
  "privacyPolicyInformationItem3": "IP地址和大致位置（僅限國家級別）",
  "privacyPolicyCookies": "Cookie和類似技術",
  "privacyPolicyCookiesContent": "我們使用Cookie來改善您在我們網站上的體驗。這些小型文字檔案使我們能夠記住您的偏好並分析我們網站的使用情況。您可以通過瀏覽器設定控制Cookie。",
  "privacyPolicyThirdParty": "第三方服務",
  "privacyPolicyThirdPartyContent": "我們的網站可能使用第三方服務，如分析提供商和內容分發網絡。這些服務可能會收集有關您使用我們網站的資訊。我們確保所有第三方都尊重您的隱私並適當處理數據。",
  "privacyPolicySecurity": "資料安全",
  "privacyPolicySecurityContent": "我們實施適當的安全措施來保護您的資訊免受未經授權的訪問、更改或披露。但是，網絡傳輸不可能100%安全，因此我們不能保證絕對的安全性。",
  "privacyPolicyChanges": "本政策的變更",
  "privacyPolicyChangesContent": "我們可能會不時更新我們的隱私政策。我們會通過在此頁面上發布新的隱私政策並更新「最後更新日期」來通知您任何變更。",
  "privacyPolicyContact": "聯絡我們",
  "privacyPolicyContactContent": "如果您對本隱私政策有任何疑問，請通過我們聯絡頁面上提供的資訊與我們聯繫。",
  "privacyPolicyLastUpdated": "最後更新",
  
  // Size matching feature
  "enterHeightWeight": "輸入您的身高和體重 — 看看哪個寶可夢與您匹配！",
  "whichPokemonMatchesSize": "哪個寶可夢符合您的體型？",
  "youAreMostLike": "您最像",
  "nameLabel": "姓名",
  "heightLabel": "身高",
  "weightLabel": "體重",
  "heightValid": "請輸入有效的身高 (1-300 cm)",
  "weightValid": "請輸入有效的體重 (1-500 kg)",
  "enterDetails": "輸入您的詳細資料",
  "finding": "搜尋中...",
  "errorFinding": "尋找您的寶可夢時出錯",
  "matchResult": "{{name}}的寶可夢是...",
  "similarityScore": "相似度分數",
  "downloadStarted": "準備您的圖片中...",
  "downloadComplete": "圖片已成功下載！",
  "shareText": "我發現我是{{pokemon}}！快來看看您是哪個寶可夢！",
  
  // Which Pokemon Am I Content Sections
  "aboutTool": "關於此工具",
  "howToUse": "如何使用",
  "benefits": "優點",
  "faq": "常見問題",
  "conclusion": "結論",
  "findMyPokemon": "尋找我的寶可夢",
  "namePlaceholder": "請輸入您的名字",
  "nameRequired": "請輸入名字",
  "downloadImage": "下載圖片",
  "tryAgain": "再試一次",
  "madeBy": "製作者",
  
  // New Page: Pokemon Randomizer - About Section Titles (Translated to Traditional Chinese)
  "pokemonRandomizerPageAboutTitle": "探索終極寶可夢隨機產生器體驗",
  "pokemonRandomizer_whatIsItTitle": "寶可夢隨機產生器究竟是什麼？",
  "pokemonRandomizer_featuresTitle": "我們寶可夢隨機產生器工具的主要特點",
  "pokemonRandomizer_whyUseTitle": "為何要与寶可夢隨機產生器一同踏上冒險？",
  "pokemonRandomizer_gettingStartedTitle": "開始使用：您的首次寶可夢隨機產生器體驗",
  "pokemonRandomizer_faqTitle": "寶可夢隨機產生器：常見問題",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Traditional Chinese)
  "pokemonRandomizerPageH1": "寶可夢隨機產生器",
  "pokemonRandomizerPageSubtitle": "使用我們的進階隨機化工具創造獨特的寶可夢體驗。",

  // Sub-Footer
  subFooterToolsTitle: "工具",
  subFooterRandomPokemonGeneratorLink: "隨機寶可夢產生器",
  subFooterPokemonRandomizerLink: "寶可夢隨機化器",
  subFooterWhichPokemonAmILink: "我是哪個寶可夢？",

  subFooterPokemonDatabaseTitle: "寶可夢資料庫",
  subFooterPokedexLink: "寶可夢圖鑑 (敬請期待)",
  subFooterTypeChartsLink: "屬性相剋表 (敬請期待)",
  subFooterMoveListLink: "招式列表 (敬请期待)",

  subFooterBlogTitle: "部落格",
  subFooterLatestArticlesLink: "最新文章 (敬请期待)",
  subFooterGuidesTutorialsLink: "指南與教學 (敬请期待)"
};
